<h2 mat-dialog-title>Gestión de {{'UnidadFuncional' | translate}}</h2>

<div mat-dialog-content>

  <mat-expansion-panel [expanded]="true">

    <mat-expansion-panel-header>
      <mat-panel-title>
        <mat-icon style="margin-top: -3px;">settings</mat-icon> Datos Generales
      </mat-panel-title>
      <mat-panel-description>
      </mat-panel-description>
    </mat-expansion-panel-header>

    <div fxLayout="row stretch" fxLayout.xs="column">
      <mat-label *ngIf="isValidating"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
      <mat-label *ngIf="!isSearching && msgError.length > 0">{{msgError}}</mat-label>
    </div>

    <form [formGroup]="formGroup" *ngIf="!isValidating">

      <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

        <div fxFlex=50 fxFlex.xs=100 class="flex-item">
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>Nombre*</mat-label>
            <input matInput formControlName="Nombre" maxlength="150" (keyup.enter)="onGuardar()">
            <mat-error
              *ngIf="!formGroup.controls['Nombre'].valid && formGroup.controls['Nombre'].touched">
              {{ getErrorNombre() }}
            </mat-error>
          </mat-form-field>
        </div>
        <div fxFlex=50 fxFlex.xs=100 class="flex-item">
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>Apellido*</mat-label>
            <input matInput formControlName="Apellido" maxlength="150" (keyup.enter)="onGuardar()">
            <mat-error
              *ngIf="!formGroup.controls['Apellido'].valid && formGroup.controls['Apellido'].touched">
              {{ getErrorApellido() }}
            </mat-error>
          </mat-form-field>
        </div>

        <div fxFlex=50 fxFlex.xs=100 class="flex-item">
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label *ngIf="!isTipoDocumentoSearching">Tipo Documento</mat-label>
            <mat-label *ngIf="isTipoDocumentoSearching">Cargando...</mat-label>
            <mat-select formControlName="TipoDocumentoId" (selectionChange)="onTipoDocumentoSelection()">
              <mat-option>Ninguno</mat-option>
              <mat-option *ngFor="let s of tipoDocumentoList" [value]="s.Id">{{s.Nombre}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div fxFlex=50 fxFlex.xs=100 class="flex-item">
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>Nro. Documento</mat-label>
            <input matInput formControlName="NroDocumento" type="text" (change)="onNroDocumentoChange()"
              maxlength="100" (keyup.enter)="onGuardar()">
            <mat-error
              *ngIf="!formGroup.controls['NroDocumento'].valid && formGroup.controls['NroDocumento'].touched">
              {{ getErrorNroDocumento() }}
            </mat-error>
          </mat-form-field>
        </div>

        <div fxFlex=50 fxFlex.xs=100 class="flex-item">
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>CUIT/CUIL</mat-label>
            <input matInput formControlName="Cuit" type="number" (keyup.enter)="onGuardar()">
          </mat-form-field>
        </div>
        <div fxFlex=50 fxFlex.xs=100 class="flex-item">
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>Mail de Contacto</mat-label>
            <input matInput formControlName="MailContacto" (keyup.enter)="onGuardar()" maxlength="255">
            <mat-error
              *ngIf="!formGroup.controls['MailContacto'].valid && formGroup.controls['MailContacto'].touched">
              {{ getErrorMailContacto() }}
            </mat-error>
          </mat-form-field>
        </div>
        
        <div fxFlex=50 fxFlex.xs=100 class="flex-item">
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>Móvil de Contacto</mat-label>
            <input matInput formControlName="MovilContacto" (keyup.enter)="onGuardar()" maxlength="100">
            <mat-error
              *ngIf="!formGroup.controls['MovilContacto'].valid && formGroup.controls['MovilContacto'].touched">
              {{ getErrorMovilContacto() }}
            </mat-error>
          </mat-form-field>
        </div>

      </div>

    </form>

  </mat-expansion-panel>

</div>

<br/>

<div mat-dialog-actions>
  <div fxLayout="row stretch" fxLayout.xs="column">
    <button mat-raised-button (click)="onGuardar()" *ngIf="canEdit" [disabled]="isProcessing()" color="primary" class="zb-button">{{isSaving ? 'Guardando...' : 'Guardar'}}</button>
    <button mat-raised-button color="warn" (click)="onCancel()" class="zb-button">Cancelar</button>
  </div>
</div>